import request from "@/utils/request";

export default function adminStopMessage(wechatMpId, days) {
    return request({
        url: `/wechatMP/adminStopMessage/`+wechatMpId+`/`+days,
        method: 'get',
    })
}